import React, { useState, useEffect } from 'react';
import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from '../Dashboard/components/AppNavbar';
import Header from '../Dashboard/components/Header';
import SideMenu from '../Dashboard/components/SideMenu';
import AppTheme from '../../../components/shared-theme/AppTheme';
import TransitionMark from '../../Transitions/TransitionMark';
import MainGridTransaksi from './components/MainGridTransaksi';
import { useParams, useLocation } from 'react-router-dom';

export default function Transaksi(props) {
    const { category } = useParams();
    const [showTransition, setShowTransition] = useState(false);
    const location = useLocation();

    useEffect(() => {
        // Trigger transition on route change
        setShowTransition(true);
        const timer = setTimeout(() => setShowTransition(false), 2000); // Show for 2 seconds
        return () => clearTimeout(timer); // Clean up timeout on unmount
    }, [location]);

    return (
        <AppTheme {...props}>
            <CssBaseline enableColorScheme />
            <Box sx={{ display: 'flex' }}>
                {showTransition && <TransitionMark />}
                {!showTransition && (
                    <>
                        <SideMenu />
                        <AppNavbar />
                        {/* Main content */}
                        <Box
                            component="main"
                            sx={(theme) => ({
                                flexGrow: 1,
                                backgroundColor: theme.vars
                                    ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                                    : alpha(theme.palette.background.default, 1),
                                overflow: 'auto',
                            })}
                        >
                            <Stack
                                spacing={2}
                                sx={{
                                    alignItems: 'center',
                                    mx: 3,
                                    pb: 5,
                                    mt: { xs: 8, md: 0 },
                                }}
                            >
                                <Header />
                                <MainGridTransaksi category={category} />
                            </Stack>
                        </Box>
                    </>
                )}
            </Box>
        </AppTheme>
    );
}
